<template>
  <!--PC端-->
  <div>
    <nav-header ref="navHeader"
                v-bind:showSearch="p_showSearch"
                v-bind:loginModalFlag="p_loginModalFlag"
                v-on:showLoginModal="p_showLoginModal"
                v-on:closeLoginModal="p_closeLoginModal"
    ></nav-header>
    <nav-bread>
      <span style="margin-right:10px;" slot="mine">个人中心</span>
      <!--<span style="margin-right:10px;" slot="orderList">我的订单</span>-->
    </nav-bread>
    <div class="container">
      <el-container>
        <div class="biaot"><p class="mshow">我的订单&nbsp;&nbsp;>&nbsp;&nbsp; 订单详情</p>
          <nav-left v-bind:activeIndex="p_activeIndex"></nav-left>
        </div>
        <el-container style="margin:40px 0 0 20px;">
          <el-header class="mhide">我的订单 &nbsp;&nbsp;>&nbsp;&nbsp; 订单号: {{orderDesc.orderNum}}</el-header>
          <div class="orderInfo" v-loading="loading">
            <div class="infoTit">订单信息</div>
            <el-main>
              <div class="detail_info">
                订单状态：
                <template v-if="user.isChannel">
                  <template v-if="orderDesc.status || orderDesc.status == 0">
                    <span style="color:#00C5B0">{{statusTag(orderDesc.status)}}</span>
                  </template>
                  <template v-else>
                    <span style="color:#00C5B0">{{orderStatusTag(orderDesc.orderStatus)}}</span>
                  </template>
                </template>
                <template v-else>
                  <template v-if="applyInfo&&(applyInfo.status == 1 || applyInfo.status == 2)">
                    <span style="color:#00C5B0">退款中</span>
                  </template>
                  <template v-else-if="applyInfo&&applyInfo.status == 4">
                    <span style="color:#00C5B0">退款成功</span>
                  </template>
                  <template v-else>
                    <template v-if="applyInfo&&(applyInfo.status == 3 || applyInfo.status == 5)">
                      <span style="color:#00C5B0">退款失败</span>
                    </template>
                    <template v-if="orderDesc.payStatus == 1 || orderDesc.payStatus == 5">
                      <span style="color:#00C5B0">{{statusTag(orderDesc.status)}}</span>
                    </template>
                    <template v-else>
                      <span style="color:#00C5B0">{{payStatusTag(orderDesc.payStatus)}}</span>
                    </template>
                  </template>
                </template>
              </div>
              <div class="detail_info" v-if="appt&&appt.groupStatus&&groupStatusTag(appt.groupStatus)">
                拼团状态： <span style="color:#00C5B0">{{groupStatusTag(appt.groupStatus)}}</span>
              </div>
              <div v-if="!appt && groupInfo">
                <div class="detail_info">
                  拼团状态： <span style="color:#00C5B0">{{groupStatusTag2(groupInfo.groupStatus)}}</span>
                </div>
                <div class="detail_info">
                  拼团号： <span>{{groupInfo.groupNum || '--'}}</span>
                </div>
              </div>
              <div class="detail_info barcode_wrap">
                <span>订单编号：</span>
                <img id="barcode"/>
              </div>
              <div class="detail_info">创建时间：{{orderDesc.addTime}}</div>
              <template v-if="appt&&appt.apptTime">
                <div class="detail_info">预约日期：{{appt.apptTime}} <template v-if="appt.apptBeginTime">{{appt.apptBeginTime}}~{{appt.apptEndTime}}</template></div>
                <div class="detail_info">受检者：{{appt.apptName}}</div>
                <!--<div class="detail_info" v-if="appt.apptUsName">姓名全拼/英文名：{{appt.apptUsName}}</div>-->
                <!--<div class="detail_info">性别：{{appt.apptSex == 1 ? '男' : '女'}}</div>-->
                <!--<div class="detail_info">手机号：{{appt.apptMobile}}</div>-->
                <div class="detail_info">{{statusTagCom(apptCertList, appt.apptCert)}}：{{appt.apptCertNo}}</div>
                <!--<div class="detail_info">在沪地址：{{appt.apptAddr}}</div>-->
                <!--<div class="detail_info">所属单位：{{appt.apptCompany}}</div>-->
                <!--<div class="detail_info">单位性质：{{appt.companyNature}}</div>-->
                <!--<div class="detail_info">来自地区：{{appt.fromRegion}}</div>-->
                <div class="detail_info">报告类型：{{appt.reportType == 0 ? '中英文' : '中文'}}</div>
                <!--<div class="detail_info">近14天是否到过疫情中高风险地区：{{appt.apptEpidemicArea == 1 ? '是' : '否'}}</div>-->
                <!--<div class="detail_info">近14天是否接触过来自疫情中高风险地区的亲属朋友：{{appt.apptContactEpidemicArea == 1 ? '是' : '否'}}</div>-->
                <!--<div class="detail_info">近14天是否接触过可疑病例及发热病人：{{appt.apptHighRiskGroups == 1 ? '是' : '否'}}</div>-->
                <!--<div class="detail_info">近14天是否有发热咳嗽等症状：{{appt.aptFeverCough == 1 ? '是' : '否'}}</div>-->
                <!--<div class="detail_info">近14天家人朋友是否有发热咳嗽等症状：{{appt.aptContactFeverCough == 1 ? '是' : '否'}}</div>-->
              </template>
              <template v-else>
                <div class="detail_info">收货人：&nbsp;&nbsp;&nbsp;{{orderDesc.userName}}</div>
                <div class="detail_info">收货地址：{{orderDesc.address}}</div>
                <div class="detail_info">手机号码：{{orderDesc.telNumber}}</div>
              </template>
            </el-main>
            <div class="infoTit">商品信息</div>
            <el-main>
              <el-table
                :data="orderDetailList"
                border
                style="width: 100%">
                <el-table-column
                  fixed
                  label="商品信息">
                  <template slot-scope="scope">
                    <span class="item_name">
                      {{scope.row.itemName}}
                    </span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="specPrice"
                  label="单价"
                  height="100"  min-width="30">
                </el-table-column>
                <el-table-column
                  prop="spec"
                  label="规格"  min-width="30">
                </el-table-column>
                <el-table-column
                  prop="itemNum"
                  label="数量"  min-width="30">
                </el-table-column>
                <!--<el-table-column-->
                <!--label="状态"-->
                <!--v-if="orderDesc.orderType == 1">-->
                <!--<template slot-scope="scope">-->
                <!--已录入{{scope.row.snNum}}个样本-->
                <!--</template>-->
                <!--</el-table-column>-->
                <el-table-column
                  label="操作" min-width="70">
                  <template slot-scope="scope">
                    <template v-if="orderDesc.payStatus == 1 && orderDesc.orderType == 1">
                      <!--<el-button-->
                      <!--@click.native.prevent="toSampleManage(orderDesc.orderNum)"-->
                      <!--type="text"-->
                      <!--size="small">-->
                      <!--查看样本-->
                      <!--</el-button>-->
                      <template v-if="orderDesc.sampleIdList && orderDesc.sampleIdList.length">
                        <template v-if="orderDesc.sampleStatus != 2 && orderDesc.sampleStatus != 3 && orderDesc.sampleStatus != 10 && orderDesc.status < 7">
                          <el-button
                            @click.native.prevent="addOrUpdateHandle('',scope.row.id, scope.row.itemId, orderDesc.id)"
                            type="text"
                            size="small">
                            修改样本
                          </el-button>
                        </template>
                        <template v-else>
                          <el-button
                            @click.native.prevent="addOrUpdateHandle('detail',scope.row.id, scope.row.itemId, orderDesc.id)"
                            type="text"
                            size="small">
                            查看标本
                          </el-button>
                        </template>
                        <el-button
                          @click.native.prevent="authorizeReport(scope.row.id,1)"
                          type="text"
                          size="small"
                          style="display: block"
                          v-if="orderDesc.agreeReportPerm == 0 && orderDesc.promotionId">
                          授权报告
                        </el-button>
                        <el-button
                          @click.native.prevent="authorizeReport(scope.row.id,0)"
                          type="text"
                          size="small"
                          style="display: block"
                          v-if="orderDesc.agreeReportPerm == 1">
                          取消授权报告
                        </el-button>
                      </template>
                      <template v-else>
                        <el-button
                          @click.native.prevent="addOrUpdateHandle('',scope.row.id, scope.row.itemId, orderDesc.id)"
                          type="text"
                          size="small"
                          v-if="orderDesc.status < 7">
                          录入样本
                        </el-button>
                      </template>
                    </template>
                  </template>
                </el-table-column>
              </el-table>

            </el-main>
            <template v-if="orderDesc.orderType == 0">
              <div class="infoTit">物流信息</div>
              <el-main>
                <el-table
                  :data="filterCourierList"
                  border
                  style="width: 100%">
                  <el-table-column
                    fixed
                    prop="expressName"
                    label="快递公司">
                  </el-table-column>
                  <el-table-column
                    prop="courierNum"
                    label="物流单号"
                    height="100">
                  </el-table-column>
                  <el-table-column
                    prop="itemName"
                    label="商品名字">
                  </el-table-column>
                  <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                      <el-button
                        @click.native.prevent="toOrderLogistics(scope.$index,filterCourierList)"
                        type="text"
                        size="small">
                        查看物流
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-main>
            </template>
            <div class="fr orderTot totalPrice"> 原价：<span class="totleMoney">￥{{orderDesc.totalPrice | FormatCurrency(orderDesc.totalPrice)}}</span></div>
            <div class="fr orderTot couponPrice"> 优惠金额：<span class="totleMoney">-￥{{orderDesc.couponPrice | FormatCurrency(orderDesc.couponPrice)}}</span></div>
            <div class="fr orderTot"> 共计{{itemNumTotal}}件商品 &nbsp; 订单总金额：<span class="totleMoney" v-if="orderDesc.payPrice">￥{{orderDesc.payPrice | FormatCurrency(orderDesc.payPrice)}}</span></div>
            <el-row class="payBtn">
              <el-col :span="24">
                <el-button
                  @click.native.prevent="toPay(orderDesc.id)"
                  type="primary"
                  size="small"
                  v-if="orderDesc.payStatus == 0 && user.isChannel == 0">
                  去支付
                </el-button>
              </el-col>
            </el-row>
          </div>
        </el-container>
      </el-container>
    </div>
    <pay-code-modal v-bind:c_mdshow='p_mdshow' v-on:c_close='p_close'>
      <p slot="msg">
        扫一扫微信支付
      </p>
      <img slot="code" class="code" :src="payCode" alt="">

      <div slot='btnGroup'>
        <a href="javascript:;" class='btn btn--m' @click='p_close'>取消</a>
      </div>
    </pay-code-modal>

    <!--标本信息弹框-->
    <sample-add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getOrderInfo()"></sample-add-or-update>
    <!--移动端-->
    <div class="mshow">
      <!--底部导航-->
      <tabbar :selected="selected" :tabs='tabs'></tabbar>
    </div>
  </div>

</template>

<script>
  import JsBarcode from 'jsbarcode'
  import axios from 'axios'
  import Tabbar from '@/components/Tabbar.vue'
  import NavHeader from '@/components/Header.vue'
  import NavFooter from '@/components/Footer.vue'
  import NavBread from '@/components/Bread.vue'
  import NavLeft from '@/components/NavLeft.vue'
  import '@/assets/css/index.css'
  import {getCookie, setCookie, removeHTMLTag, getCurrentTime, IsPC} from "../../util/util";
  import PayCodeModal from "../../components/PayCodeModal";
  import SampleAddOrUpdate from '../../components/sample-add-or-update'

  export default {
    name: "orderdesc",
    data() {
      return {
        addOrUpdateVisible: false,
        groupInfo: null,  // 如有, 拼团信息
        orderDetailList: [],
        courierList: [],
        filterCourierList: [],
        orderid: this.$route.query.id,
        itemNumTotal: this.$route.query.itemNumTotal,
        orderDesc: {},
        appt: {},
        advertiseList: [],
        selected: "Mine",
        tabs: [
          require("@/assets/hose_grey.png"),
          require("@/assets/shopping_grey.png"),
          require("@/assets/me_Filled.png")
        ],
        limit: 10,
        page: 1,
        orderList: [],
        p_activeIndex: this.$route.query.p_activeIndex || "1",
        p_showSearch: true,
        p_loginModalFlag: false,
        loading: true,
        interval:{},
        p_mdshow:false,
        payStatus:0,
        payCode:'',
        isWeChat:false,
        code:'0',
        appid: '',
        payType:0,
        qrCodeFlag:1,
        // 订单状态
        statusList: [
          {
            status: 0,
            label: '未支付'
          },
          {
            status: 1,
            label: '待发货'
          },
          {
            status: 2,
            label: '已发货'
          },
          {
            status: 3,
            label: '待录入样本'
          },
          {
            status: 4,
            label: '录入中'
          },
          {
            status: 5,
            label: '待确认'
          },
          {
            status: 6,
            label: '已确认'
          },
          {
            status: 7,
            label: '已送样'
          },
          {
            status: 8,
            label: '已收样'
          },
          {
            status: 9,
            label: '检测中'
          },
          {
            status: 10,
            label: '报告生成'
          },
          {
            status: 11,
            label: '支付超时'
          },
          {
            status: 12,
            label: '取消订单'
          },
          {
            status: 13,
            label: '已拒绝'
          }
        ],
        orderStatusList: [
          {
            status: 0,
            label: '待确认'
          },
          {
            status: 1,
            label: '已确认'
          },
          {
            status: 2,
            label: '部分发货'
          },
          {
            status: 3,
            label: '全部发货'
          },
          {
            status: 4,
            label: '订单完成'
          },
          {
            status: 5,
            label: '客户取消'
          },
          {
            status: 6,
            label: '厂家取消'
          }
        ],
        groupStatusList: [
          // {
          //   status: '-1',
          //   label: '不参与'
          // },
          {
            status: '0',
            label: '拼团中'
          },
          {
            status: '1',
            label: '拼团中'
          },
          {
            status: '2',
            label: '拼团成功'
          },
          {
            status: '9',
            label: '拼团失败'
          }
        ],
        groupStatusList2: [
          {
            status: 0,
            label: '拼团中'
          },
          {
            status: 1,
            label: '拼团成功'
          },
          {
            status: 9,
            label: '拼团失败'
          }
        ],
        payStatusList: [
          {
            status: 0,
            label: '未支付'
          },
          {
            status: 1,
            label: '已支付'
          },
          {
            status: 2,
            label: '已取消'
          },
          {
            status: 3,
            label: '退款中'
          },
          {
            status: 4,
            label: '退款成功'
          },
          {
            status: 5,
            label: '退款失败'
          }
        ],
        apptCertList: [
          {
            value: '0',
            label: '身份证'
          },
          {
            value: '1',
            label: '中国护照'
          },
          {
            value: '2',
            label: '台胞证'
          },
          {
            value: '3',
            label: '回乡证'
          },
          {
            value: '5',
            label: '中国绿卡'
          },
          {
            value: '4',
            label: '外籍护照'
          },
          {
            value: '7',
            label: '往来台湾通行证'
          },
          {
            value: '8',
            label: '往来港澳通行证'
          }
        ]
      }
    },
    components: {
      PayCodeModal,
      Tabbar,
      SampleAddOrUpdate,
      NavHeader,
      NavFooter,
      NavBread,
      NavLeft
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
      statusTag () {
        return function (code) {
          return (this.statusList.find(e => e.status === code) || { label: '暂无' }).label
        }
      },
      orderStatusTag () {
        return function (code) {
          return (this.orderStatusList.find(e => e.status === code) || { label: '暂无' }).label
        }
      },
      groupStatusTag () {
        return function (code) {
          return (this.groupStatusList.find(e => e.status === code) || { label: '暂无' }).label
        }
      },
      groupStatusTag2 () {
        return function (code) {
          return (this.groupStatusList2.find(e => e.status === code) || { label: '暂无' }).label
        }
      },
      payStatusTag () {
        return function (code) {
          return (this.payStatusList.find(e => e.status === code) || { label: '暂无' }).label
        }
      },
      statusTagCom () {
        return function (arr, code) {
          return (arr.find(e => e.value == code) || { label: '--' }).label
        }
      }
    },
    mounted() {
      if (getCookie("_token")) {
        this.getOrderInfo()
      } else {
        this.$message({
          showClose: true,
          message: '登录信息失效,请重新登录',
          type: 'error'
        });
        this.$refs.navHeader.logout()
      }
    },
    methods: {
      p_close(){
        this.p_mdshow = false;
        this.$message.error("支付已取消")
        clearInterval(this.interval);
      },

      p_showLoginModal() {
        this.p_loginModalFlag = true
      },

      p_closeLoginModal() {
        this.p_loginModalFlag = false
      },

      //获取订单详情
      getOrderInfo() {
        let that = this
        let orderType = this.$route.query.orderType
        let requestUrl = orderType == 1 ? "/jys/order/info/" : "/jys/order/channelHospital/"
        axios.get(requestUrl + this.orderid, {
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token")
          }
        }).then((res) => {
          if (res.data.code == 0) {
            this.loading = false
            this.orderDesc = res.data.order
            this.groupInfo = res.data.group
            this.applyInfo = res.data.apply
            // 预约信息
            if (res.data.appt) {
              res.data.appt.apptTime = res.data.appt.apptTime.substring(0 , 10)
            }
            this.appt = res.data.appt

            let mylist = res.data.order.orderDetailList
            for (var i = 0; i < mylist.length; i++) {
              mylist[i].totleMoney = mylist[i].itemNum * mylist[i].itemPrice
            }
            this.orderDetailList = mylist
            console.log('orderDetailList', this.orderDetailList)
            this.courierList = res.data.order.courierList
            this.filterCourierList = res.data.order.courierList.filter(function (item, index, arr) {
              return item.courierNum
            })

            if(this.isWeChatFun()){
              this.isWeChat = true
              this.getAppid(res.data.order.id)
            }

            this.$nextTick(() => {
              setTimeout(function () {
                that.createBarcode(res.data.order.orderNum)
              }, 200)
            })
          }
        })
      },

      createBarcode (uniqueCode) {
        JsBarcode('#barcode', uniqueCode, {
          format: 'CODE128',
          lineColor: '#000',
          background: '#FFFFFF',
          displayValue: true,
          fontSize: 14,
          width: 1,
          height: 30
        })
      },

      //查看物流
      toOrderLogistics(index, couOrderList) {
        this.$router.push({
          path: "/mine/orderLogistics",
          query: {courierNum: couOrderList[index].courierNum, courierCo: couOrderList[index].courierCo}
        })
      },

      //查看样本
      toSampleManage (orderNum) {
        this.$router.push({path: "/mine/sampleManage", query: {orderNum: orderNum}})
      },

      //录入标本 id:标本ID
      addOrUpdateHandle (fromPath, detailItemId, itemId, orderId) {
        this.addOrUpdateVisible = true
        this.$nextTick(() => {
          this.$refs.addOrUpdate.init(fromPath,detailItemId,itemId,orderId)
        })
      },

      //授权报告
      authorizeReport (detailItemId,flag) {
        if(flag == 1){
          this.$confirm('确定授权您的医生查看报告?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.authorizeReportFun(detailItemId,flag)
          }).catch(error => {
            console.log(error)
          });
        }else{
          this.$confirm('取消授权您的医生查看报告?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.authorizeReportFun(detailItemId,flag)
          }).catch(error => {
            console.log(error)
          });
        }
      },

      authorizeReportFun (detailItemId,flag) {
        axios.post("/jys/userSample/updateReportPerm", {
          detailItemId:detailItemId,
          agreeReportPerm:flag
        }).then((res) => {
          if (res.data.code == 0) {
            this.getOrderInfo()
            if(flag == 1){
              this.$message({
                message: '授权成功',
                type: 'success'
              });
            }else{
              this.$message({
                message: '取消授权成功',
                type: 'success'
              });
            }
          }
        })
      },

      //去支付
      toPay(id){
        if(!IsPC()){
          let isSupport = false
          if (this.isWeChatFun()) {
            // 微信浏览器都支持
            isSupport = true
          } else {
            // 手机浏览器只支持之江
            isSupport = this.orderDesc.providerId === 1 || this.orderDesc.providerId === 21;
          }
          if (isSupport) {
            this.$confirm('请选择支付方式?', '提示', {
              distinguishCancelAndClose: true,
              confirmButtonText: '微信支付',
              cancelButtonText: '生成二维码',
              type: 'warning',
              center: true,
              showClose: true
            }).then(() => {
              if (this.isWeChatFun()) {
                this.qrCodeFlag = 0
              } else {
                this.qrCodeFlag = 2
              }
              this.payType = 3
              this.rePay(id)
            }).catch(action => {
              if(action === 'cancel') {
                window.scrollTo(0, 0)
                this.payType = 0
                this.qrCodeFlag = 1
                this.rePay(id)
              }else{
                this.$message.error('支付已取消')
              }
            });
          } else {
            window.scrollTo(0, 0)
            this.payType = 0
            this.qrCodeFlag = 1
            this.rePay(id)
          }
        }else{
          window.scrollTo(0, 0)
          this.payType = 0
          this.qrCodeFlag = 1
          this.rePay(id)
        }
      },

      rePay(id){
        axios.put("/jys/pay/rePay",{
          orderId:id,
          code: this.code,
          payType: this.payType,
          qrCodeFlag: this.qrCodeFlag,
          orderPlatform: 1
        }).then((response)=>{
          if(response.data.code == 0){
            this.loading = false
            let result = response.data.result
            let codeUrlPng = result.codeUrlPng
            let orderNo = result.orderNo
            if(this.payType == 3){
              if (this.qrCodeFlag == 0) {
                if(typeof WeixinJSBridge == "undefined") {
                  if(document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                  } else if(document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                    document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                  }
                } else {
                  this.onBridgeReady(result);
                }
              } else {
                location.href = response.data.result.mwebUrl
              }
            }else{
              this.p_mdshow = true
              this.payCode = 'data:image/png;base64,' + codeUrlPng
            }

            var interval = setInterval(() =>{
              this.getPayStatus(orderNo)
              if(this.payStatus == 1){
                clearInterval(interval);
                this.$message.success("支付成功")
                this.getOrderInfo()
                this.p_mdshow = false;
              }
            }, 2000);

            this.interval = interval
          } else if (response.data.code == 500) {
            setTimeout(() => {
              if (this.isWeChatFun()) {
                this.reload()
              }
            }, 1000)
          }
        })
      },

      //获取订单支付状态
      getPayStatus(orderNo){
        axios.get("/jys/pay/status/" + orderNo,{
          headers:{
            "Content-Type": "application/json",
            'token': getCookie("_token")
          }
        }).then((response) => {
          if(response.data.code == 0){
            let status = response.data.status
            this.payStatus = status
          }
        })
      },
      //判断是否是微信浏览器
      isWeChatFun(){
        let ua = window.navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger'){
          return true;
        }else{
          return false;
        }
      },
      //获取地址栏参数
      GetQueryString(name) {
        let reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
        let r = window.location.search.substr(1).match(reg);
        if(r!=null)return  unescape(r[2]); return null;
      },
      //微信获取appid
      getAppid(id){
        axios.get("/jys/pay/appid", {
          params: {
            orderId: id
          }
        }).then((res) => {
          if (res.data.code === 0) {
            this.appid = res.data.appid
            this.getCode(res.data.appid)
          }
        })
      },
      //微信授权获取code
      getCode(appid){
        let code = this.GetQueryString('code')
        if(code != null && code.toString().length>1) {
          this.code = code
        }else{
          //redirect_uri授权后重定向的回调链接地址
          location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + encodeURIComponent(location.href) + '&response_type=code&scope=snsapi_base&state=0#wechat_redirect';
        }
      },
      //微信支付
      onBridgeReady(data){
        let that = this
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            "appId": data.appid,//公众号名称
            "timeStamp": data.timeStamp,//时间戳
            "nonceStr": data.nonceStr, //随机串
            "package": data.package,
            "signType":"MD5",//微信签名方式
            "paySign": data.paySign//微信签名
          },
          function(res){
            if(res.err_msg == "get_brand_wcpay_request:ok" ) {

            }else if(res.err_msg == "get_brand_wcpay_request:cancel") {
              that.reload()
            }else if(res.err_msg == "get_brand_wcpay_request:fail"){
              that.reload()
              that.$message.error(JSON.stringify(res))
            }else{
              that.reload()
            }
          }
        )
      },
      //重新加载
      reload(){
        let href = location.href;
        let posit = href.indexOf("com/") + 4; //获取域名结束的位置
        let urlLeft = href.substring(0, posit);//url左侧部分
        let urlRight = href.split('#')[1]; //url右侧部分
        let url = urlLeft + "#" + urlRight;//拼接跳转
        window.history.pushState({}, 0, url)
        this.getAppid(this.orderDesc.id)
      },
      //跳转到详情页
      todetection(itemId, remark) {
        this.$router.push({
          path: "detection",
          query: {
            id: itemId,
            remark: remark
          }
        })
      }
    }
  }
</script>

<style scoped>
  .item_name {
    /* cursor: pointer; */
  }
  .el-button + .el-button{
    margin-left: 0;
  }

  .fr {
    float: right;
  }

  .totleMoney {
    font-size: 28px;
    color: #FE2042;
  }

  .orderTot {
    width: 100%;
    /*margin-left: 70%;*/
    margin:0 20px 20px 0;
    text-align: right;
  }

  .orderTot.totalPrice,
  .orderTot.couponPrice{
    margin:0 20px 5px 0;
  }

  .totalPrice .totleMoney,
  .couponPrice .totleMoney{
    font-size: 20px;
  }

  .orderInfo {
    width: 100%;
    background: #fff;
    margin-top: 20px;
  }

  .orderInfo .detail_info {
    margin-left: 8px;
    height: 30px;
    line-height: 30px;
  }

  .orderInfo .infoTit {
    /*width: 100%;*/
    margin-left: 0 !important;
    background: #F0F0F0;
    height: 40px;
    line-height: 40px;
    padding-left: 30px;
    /*margin-bottom: 20px;*/
    color: #000
  }

  .userInfo {
    width: 100%;
    height: 150px;
    margin-top: 20px;

  }

  .userInfo .img_box {
    width: 40%;
    height: 100%;
    float: left;
  }

  .userInfo .img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }

  .userInfo .info_box {
    width: 60%;
    float: left;
  }

  .userInfo .info {
    display: block;
    height: 40px;
    line-height: 40px;
    text-align: left;
  }
  .el-menu-item.is-active {
    color: #00C5B0;
  }
  .mshow,.mhide{
    display: none;}
  .payBtn{
    text-align: right;
  }
  .payBtn .el-button{
    padding: 12px 76px;
  }
  .barcode_wrap {
    height: 60px !important;
  }
  .barcode_wrap * {
    vertical-align: middle;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .container{
      width: 95%;
    }
    .el-container{
      margin: 0 0 20px 0 !important;
    }
    .el-main {
      padding: 17px;
      font-size: 11px;
    }
    .el-header {
      padding: 0 15px;
    }
    .orderInfo .detail_info {
      height: initial!important;
    }
    .biaot {
      background-color: #F0F0F0;
      color: #333;
      font-size: 11px;
      text-align: left;
      position: relative;
      line-height: 32px;
      margin: 0 -10px 0;
      padding: 0 10px;
      border-left: 5px solid #00C5B0;
    }
    .mshow{
      display: inline-block;}
    .biaot div {
      position: absolute;
      right: 0;
      height: 32px;
      top: 0;
    }
    /deep/ .navbar-right-container,/deep/ .navbar-left-container img,/deep/ .hideel{
      display: none!important;
    }
    /deep/ .out{
      color: rgba(0, 196, 170, 1);
      padding-left: 0;
      margin-right: 20px;
    }
    .orderInfo .infoTit{
      margin-left: 0 !important;
      background: #F0F0F0;
      height: 30px;
      font-size: 11px;
      line-height: 30px;
      padding-left: 10px;

      color: rgb(74, 74, 74);
    }.totleMoney {
       font-size: 17px !important;}
    /deep/ .mint-tabbar.is-fixed {
      z-index: 17;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/OrderDesc.vue